function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Modifier from 'ember-modifier';
import { openModal, dismissModal } from '@market/ember';
/*
 * Automatically opens the modal template it's attached to on first render.
 *
 * Usage:
 *
 * {!-- parent.hbs --}
 * <CoolModal {{open-modal}} />
 *
 * {!-- cool-modal.hbs --}
 * <template ...attributes>
 *   <market-modal-partial>
 *     Cool modal content goes here
 *   </market-modal-partial>
 * </template>
 */

export default class OpenModal extends Modifier {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "modal", void 0);
  }
  async didInstall() {
    const selector = this.args.positional[0];
    this.modal = await openModal(this.element, selector);
  }
  willDestroy() {
    // Don't dismiss the modal if it is no longer present in the DOM.
    if (this.modal !== undefined && document.getElementById(this.modal.id)) {
      dismissModal(this.modal);
    }
    this.modal = undefined;
  }
}